import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Chip,
} from "@mui/material";
import { StockOutAlert } from "./types";
import { formatToMillions, roundToDecimalPlaces } from "../../../utils/numbers";

export const StockOutList = ({ alerts }: { alerts: StockOutAlert[] }) => {
  if (alerts.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No stock outs found
      </Typography>
    );
  }

  // Sort by revenue at risk (descending)
  const sortedAlerts = [...alerts].sort(
    (a, b) => b.revenue_at_risk - a.revenue_at_risk
  );

  // Show top 20 for performance
  const displayAlerts = sortedAlerts.slice(0, 20);

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell><strong>SKU</strong></TableCell>
            <TableCell><strong>Location</strong></TableCell>
            <TableCell><strong>Category</strong></TableCell>
            <TableCell align="right"><strong>Weeks Out</strong></TableCell>
            <TableCell align="right"><strong>Recent Demand</strong></TableCell>
            <TableCell align="right"><strong>Revenue at Risk</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {displayAlerts.map((alert, index) => (
            <TableRow
              key={`${alert.sku}-${alert.location}-${index}`}
              sx={{ "&:hover": { backgroundColor: "action.hover" } }}
            >
              <TableCell>
                <Typography variant="body2" sx={{ fontFamily: "monospace" }}>
                  {alert.sku}
                </Typography>
              </TableCell>
              <TableCell>{alert.location}</TableCell>
              <TableCell>
                <Chip
                  label={alert.product_category}
                  size="small"
                  variant="outlined"
                />
              </TableCell>
              <TableCell align="right">
                <Typography variant="body2" color="error">
                  {alert.weeks_out_of_stock} weeks
                </Typography>
              </TableCell>
              <TableCell align="right">
                {roundToDecimalPlaces(alert.recent_demand_qty)} units
              </TableCell>
              <TableCell align="right">
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {formatToMillions(alert.revenue_at_risk)}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {alerts.length > 20 && (
        <Typography
          variant="caption"
          sx={{ p: 1, display: "block", textAlign: "center", color: "text.secondary" }}
        >
          Showing top 20 of {alerts.length} stock outs (sorted by revenue at risk)
        </Typography>
      )}
    </TableContainer>
  );
};
